/**
 * FreeUsageExhaustedModal — shown when the backend answers 402 because the
 * workspace's token balance has reached the floor and a paid operation was
 * refused: the free usage is spent, or the credits bought since ran out.
 *
 * Admins get a primary action that opens Plans & Billing, where they can buy
 * credits; Editors and Viewers cannot reach that tab (the backend answers
 * 403), so they are told to ask an Admin and the primary action simply closes.
 */
import React from 'react';

import { Modal, SparkModalPortal } from '@spark';

import './FreeUsageExhaustedModal.css';

export const FREE_USAGE_EXHAUSTED_MODAL_WIDTH = 520;
export const FREE_USAGE_EXHAUSTED_TITLE = 'Not enough credits';
export const FREE_USAGE_EXHAUSTED_BODY_ADMIN = 'Buy credits to continue.';
export const FREE_USAGE_EXHAUSTED_BODY_MEMBER = 'Ask a workspace Admin to buy credits to continue.';
export const FREE_USAGE_EXHAUSTED_CTA_ADMIN = 'Buy Credits';
export const FREE_USAGE_EXHAUSTED_CTA_MEMBER = 'Got it';

export default function FreeUsageExhaustedModal({ open = false, canUpgrade = false, onClose, onUpgrade }) {
    const close = () => onClose?.();
    const primary = canUpgrade ? () => onUpgrade?.() : close;
    return (
        <SparkModalPortal open={open} onClose={close} width={FREE_USAGE_EXHAUSTED_MODAL_WIDTH} destroyOnClose>
            <Modal
                open
                className="free-usage-exhausted-modal"
                feedbackType="warning"
                title={FREE_USAGE_EXHAUSTED_TITLE}
                subtitle={canUpgrade ? FREE_USAGE_EXHAUSTED_BODY_ADMIN : FREE_USAGE_EXHAUSTED_BODY_MEMBER}
                showOverlay={false}
                showScrollBar={false}
                showTertiaryButton={false}
                fixedHeight={false}
                primaryLabel={canUpgrade ? FREE_USAGE_EXHAUSTED_CTA_ADMIN : FREE_USAGE_EXHAUSTED_CTA_MEMBER}
                onPrimaryClick={primary}
                onCloseClick={close}
            />
        </SparkModalPortal>
    );
}
